import React from "react";
import { theme } from "src/config";
import styled from "styled-components";

export interface IStackCardProps { }


const Container = styled.div`
  position:      absolute;
  border:        1px solid ${theme.color.primaryBorder};
  border-radius: 4px;
  height:        12rem;
  width:         20rem;
  top:           -6px;
  left:          -6px;
  background-color: #FFFFFF;
`;

export const StackCard = (props: IStackCardProps): JSX.Element => {
  const { } = props;

  return <Container />;
}